export interface ServiceCategoryPalette {
  headerBg: string
  headerText: string
  avatarBg: string
  avatarText: string
}

export const DEFAULT_SERVICE_CATEGORY_PALETTE: ServiceCategoryPalette = {
  headerBg: '#f4f5f8',
  headerText: '#6c7285',
  avatarBg: '#f4f5f8',
  avatarText: '#6c7285',
}

const SERVICE_CATEGORY_PALETTES: Record<string, ServiceCategoryPalette> = {
  'Bed Bugs': {
    headerBg: '#fbe7e2',
    headerText: '#c71e00',
    avatarBg: '#fff1ea',
    avatarText: '#c71e00',
  },
  'Punaises de lit': {
    headerBg: '#fbe7e2',
    headerText: '#c71e00',
    avatarBg: '#fff1ea',
    avatarText: '#c71e00',
  },
  'Rodent Control (Rats / Mice)': {
    headerBg: '#fbf0e0',
    headerText: '#b45309',
    avatarBg: '#fdf4e3',
    avatarText: '#b45309',
  },
  'Dératisation (Rats / Souris)': {
    headerBg: '#fbf0e0',
    headerText: '#b45309',
    avatarBg: '#fdf4e3',
    avatarText: '#b45309',
  },
  'Wasps / Hornets': {
    headerBg: '#fbf3d9',
    headerText: '#a16207',
    avatarBg: '#fcf7e7',
    avatarText: '#a16207',
  },
  'Guêpes / Frelons': {
    headerBg: '#fbf3d9',
    headerText: '#a16207',
    avatarBg: '#fcf7e7',
    avatarText: '#a16207',
  },
  Cockroaches: {
    headerBg: '#fff1ea',
    headerText: '#ff5a1f',
    avatarBg: '#fff7ed',
    avatarText: '#ff5a1f',
  },
  Cafards: {
    headerBg: '#fff1ea',
    headerText: '#ff5a1f',
    avatarBg: '#fff7ed',
    avatarText: '#ff5a1f',
  },
  Pigeons: {
    headerBg: '#e7efff',
    headerText: '#2563eb',
    avatarBg: '#edf4ff',
    avatarText: '#2563eb',
  },
  'Termites & Wood-boring Insects': {
    headerBg: '#e0f4f2',
    headerText: '#0d9488',
    avatarBg: '#eaf9f6',
    avatarText: '#0d9488',
  },
  'Termites & Insectes xylophages': {
    headerBg: '#e0f4f2',
    headerText: '#0d9488',
    avatarBg: '#eaf9f6',
    avatarText: '#0d9488',
  },
  'Processionary Caterpillars': {
    headerBg: '#f0f7e2',
    headerText: '#65a30d',
    avatarBg: '#f6fae7',
    avatarText: '#65a30d',
  },
  'Chenilles processionnaires': {
    headerBg: '#f0f7e2',
    headerText: '#65a30d',
    avatarBg: '#f6fae7',
    avatarText: '#65a30d',
  },
  'General Insect Control': {
    headerBg: '#eff0f4',
    headerText: '#6c7285',
    avatarBg: '#f4f5f8',
    avatarText: '#6c7285',
  },
  Désinsectisation: {
    headerBg: '#eff0f4',
    headerText: '#6c7285',
    avatarBg: '#f4f5f8',
    avatarText: '#6c7285',
  },
}

export const SERVICE_CATEGORY_ORDER = [
  'Bed Bugs',
  'Punaises de lit',
  'Rodent Control (Rats / Mice)',
  'Dératisation (Rats / Souris)',
  'Wasps / Hornets',
  'Guêpes / Frelons',
  'Cockroaches',
  'Cafards',
  'Pigeons',
  'Termites & Wood-boring Insects',
  'Termites & Insectes xylophages',
  'Processionary Caterpillars',
  'Chenilles processionnaires',
  'General Insect Control',
  'Désinsectisation',
]

export function getServiceCategoryPalette(
  name: string
): ServiceCategoryPalette {
  return (
    SERVICE_CATEGORY_PALETTES[name.trim()] ?? DEFAULT_SERVICE_CATEGORY_PALETTE
  )
}
